import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Import Font Awesome Vue component
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faSearch, 
  faDownload, 
  faStar, 
  faChevronLeft, 
  faChevronRight, 
  faTimes,
  faHouse,
  faChartDiagram,
  faCode,
  faBookOpen,
  faEnvelope,
  faRightToBracket,
  faBars,
  faEye,
  faCopy,
  faClock
} from '@fortawesome/free-solid-svg-icons'

// Import global plugin utility
import globalPlugin from './utils/global-plugin'

// Add icons to the library
library.add(
  faSearch, 
  faDownload, 
  faStar, 
  faChevronLeft, 
  faChevronRight, 
  faTimes,
  faHouse,
  faChartDiagram,
  faCode,
  faBookOpen,
  faEnvelope,
  faRightToBracket,
  faBars,
  faEye,
  faCopy,
  faClock
)

const app = createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(globalPlugin)
app.use(router).mount('#app')
